export default "__VITE_ASSET__Bc0Gr$_I__"